import { routerReducer } from '@ngrx/router-store';
import { securityGroupsReducers } from 'src/app/admin/security-groups/store/reducers';
import { cloneUserReducers } from 'src/app/admin/clone-user/store/reducers';
import { integrationMappingsReducer } from '../integration-mappings/state/integration-mappings.reducer';
import { integrationDashboardReducer } from '../integration-dashboard/state/integration-dashboard.reducers';
import { integrationManagev2Reducer } from '../integration-managev2/state/integration-managev2-config.reducer';
import { integrationEventLogDetailsReducer } from '../integration-event-log-details/state/integration-event-log-details.reducers';

export const AdminReducers = {
    routerState: routerReducer,
    //TODO: this doesn't work with AOT (security-groups/store/reducers/index.ts). Find better way to merge in reducers or provide a separate Module to each menu-item
    // ...securityGroupsReducers,

    securityState: securityGroupsReducers.securityState,
    cloneUserState: cloneUserReducers.cloneUserState,
    integrationMappingsState: integrationMappingsReducer,
    integrationDashboardState: integrationDashboardReducer,
    integrationManagev2State: integrationManagev2Reducer,
    integrationEventLogDetailsState: integrationEventLogDetailsReducer
};
